// Espelha os parâmetros da rota no contextStore (a rota é a fonte de verdade — REQ-FE-003).
import { useEffect } from 'react';

import { useMe } from '../auth/authContext';
import { invalidatePurposeForContext } from '../purpose/purposeStore';
import {
  browserPreferenceStorage,
  readContextPreference,
  writeContextPreference,
} from './contextPreferences';
import { defaultSiteId, findContext } from './contextResolver';
import { contextKey, useContextStore } from './contextStore';

export interface ContextRouteSyncProps {
  readonly scope: 'network' | 'tenant';
  readonly tenantCode?: string | undefined;
  readonly studyCode?: string | undefined;
}

export function ContextRouteSync({ scope, tenantCode, studyCode }: ContextRouteSyncProps) {
  const me = useMe();
  const mirror = useContextStore((s) => s.mirror);

  useEffect(() => {
    if (scope === 'network') {
      mirror({
        userId: me.user.id,
        isNetworkScope: true,
        activeTenantCode: null,
        activeTenantId: null,
        activeSiteId: null,
        activeStudyCode: null,
      });
    } else {
      const context = findContext(me, tenantCode);
      if (!context) {
        return;
      }
      const state = useContextStore.getState();
      const sameTenant = state.activeTenantCode === context.code;
      const remembered = readContextPreference(browserPreferenceStorage(), me.user.id);
      const siteId = sameTenant
        ? state.activeSiteId
        : defaultSiteId(
            context,
            remembered?.tenantCode === context.code ? remembered.siteId : null,
          );
      mirror({
        userId: me.user.id,
        isNetworkScope: false,
        activeTenantCode: context.code,
        activeTenantId: context.tenantId,
        activeSiteId: siteId,
        activeStudyCode: studyCode ?? null,
      });
      writeContextPreference(browserPreferenceStorage(), me.user.id, {
        tenantCode: context.code,
        siteId,
      });
    }
    invalidatePurposeForContext(contextKey(useContextStore.getState()));
  }, [me, mirror, scope, tenantCode, studyCode]);

  return null;
}
